/** P9-UI: the image pass puts the hero at the top of `body_md` (Statamic takes it from there) AND, since
 * P1-AUSGABE E9-2, into `hero_image_url`. The workspace renders `hero_image_url` above the title, so the
 * leading body copy of the SAME image is dropped from the preview — the stored body stays unchanged. */
const LEADING_IMG_RE = /^\s*!\[[^\]]*\]\(\s*<?([^)\s>]+)>?(?:\s+"[^"]*")?\s*\)[ \t]*(?:\r?\n)*/;

const base = (url: string) => url.split(/[?#]/)[0];

export function bodyWithoutHero(body: string, heroUrl: string | null | undefined): string {
  if (!heroUrl) return body;
  const m = LEADING_IMG_RE.exec(body);
  return m && base(m[1]) === base(heroUrl) ? body.slice(m[0].length) : body;
}
